import { layoutPublicUrl } from './../../constants/index';
import { Redirect } from 'react-router-dom';
import { ReactNode } from "react";
import { observable, action, runInAction, toJS, reaction } from "mobx";
import { Dialog, RootLayoutMenuData, utils } from '@weapp/ui';
import { corsImport, getLabel, getReadySuccessHook, regReadyHook, setTitle } from "@weapp/utils";

import {
  needLayout,
  setNav,
  cloneObj,
  getCookie,
  doResize,
  navNeedShow,
  needShowEm,
  inPCClient,
  getBrowserTitle,
  updateMenuInfoData,
  setBrowserTitle,
  setDialogConfig,
  isProOrBetaEnv,
  isPreview,
  isProductEnv,
  isPreviewToolMenu,
  isPreviewClient,
  isShowEMByUrl,
  isCusapp, isFirefox
} from "../../utils";
import { headerMenuStore, headerTenantStore } from "./navigation/store";
import {
  HeaderDialogNames,
  LayoutModes,
  DialogsVisibleType,
  PcThemePluginData, CustomDialogParams, ClientNavType, topicStyleType, clientTypeLayoutModeMap
} from "./types";
import * as InviteWelfareAPI from '../../api/inviteWelfare'
import * as mainAPI from "../../api/mainApi";
import { LayoutSDK, mainStore } from "../../lib";
import { NavMenuItem, ShowWays } from "./navigation/widgets/quickToolbar/types";
import * as LockAPI from "../../api/lock";
import * as AppAPI from "../../api/AppManage";
import * as NavAPI from "../../api/getListData";
import { queryExternalEmployees } from '../../api/mainApi';
import { OuterIdentityItem } from './navigation/widgets/outerIdentityCom/types';
import { HeaderMenuStore } from "./navigation/stores/headerMenuStore";
const { isEqual } = utils;


const { message } = Dialog;

const loopMenu = (
  list: Array<any>,
  map: any,
  pathIdMap: any,
  parent: any,
  isSp = false
) => {
  if (list.some((item) => item.order)) {
    list = list.sort((a, b) => {
      return a.order - b.order;
    });
  }
  list = list
    .filter((item) => (item.status !== false && item.content !== ''))
    .map((item: any) => {
      map[item.id] = item;
      // 处理父级的key
      if (parent) {
        item.parentIds = [parent.id];
        if (parent.parentIds) {
          item.parentIds = parent.parentIds.concat(item.parentIds);
        }
      }
      if (item.path) {
        if (isSp) {
          if (
            !item.needOpenNewPage &&
            /^\//.test(item.path) &&
            item.path.indexOf("/splayout") === -1
          ) {
            item.path = `/splayout${item.path}`;
          }
        }
        const mapPath = item.path.split('?')[0];
        pathIdMap[mapPath] = item.id;
      }
      if (item.children) {
        item.children = loopMenu(item.children, map, pathIdMap, item, isSp);
      }
      if (item.path && /^\//.test(item.path) && window.TEAMS?.runMode === 'txproduction') {
        item.path = item.path.replace('/splayout', '');
      }
      return item;
    });
  return list;
};

const formatMenuData = (list: Array<any>, isSp = false, needCopy: boolean = false) => {
  try {
    const menuMap = {};
    const pathIdMap = {};
    if (needCopy) {
      list = cloneObj(list);
    }
    list = loopMenu(list, menuMap, pathIdMap, undefined, isSp);
    return {
      list,
      map: menuMap,
      pathIdMap: pathIdMap,
    };
  } catch (error) {
    console.error("解析菜单出错", list);
    console.error(error);
    return {
      list: [],
      map: {},
    };
  }
};

//TODO 客户端主题兼容客户端导航老数据处理
const configName = `system.layout.clientNavType.tenant${window.TEAMS?.currentTenant?.tenantKey}`;

export class MainStore {
  @observable payTip: string = '';
  /* 导航布局方向 */
  @observable layoutMode: LayoutModes = window.inExternalSpace ?
    'h' : (
      //TODO 非指定主题的时候客户端主题兼容客户端导航老数据处理
      (
        !(Number(window.TEAMS?.theme?.topicAppoint) === 1 || Number(window.TEAMS?.theme?.topicAppoint) === 2) &&
        inPCClient() &&
        window.TEAMS?.userConfig?.[configName] &&
        clientTypeLayoutModeMap[window.TEAMS?.userConfig?.[configName]]
      ) ?
        clientTypeLayoutModeMap[window.TEAMS?.userConfig?.[configName]] : //客户端主题老个人数据
        (
          (isPreview() ? isPreviewClient() : window.TEAMS?.theme?.topicStyle === 'client') ?
            (clientTypeLayoutModeMap[window.TEAMS?.theme?.topicLayout || 0] as LayoutModes) : //pc客户端主题导航方式
            (window.TEAMS?.theme?.layout as LayoutModes || 'h') //网页版主题导航方式
        )
    );
  //主题风格
  @observable themeStyle: topicStyleType = window.TEAMS?.theme?.topicStyle || 'dark';
  // @observable layoutMode: LayoutModes = 'vSimple';

  /* 所有弹框显示配置 */
  @observable asideVisible: boolean = true; //侧边栏折叠状态
  @observable asideAvailable: boolean = false; //是否存在侧边栏
  @observable dialogsVisible: DialogsVisibleType = {
    tenantDialog: false, //创建团队
    clientDialog: false, //客户端下载
    recommendDialog: false, //推荐拿福利
    cookieDialog: false, //清除缓存
    appConfigDialog: false, //应用展示
    inviteDialog: false, //邀请
    createDialog: false, //新建
    feedBackDialog: false, //意见反馈
    appBuilderDialog: false, //构建应用
    appNoMenuBuilderDialog: false, //构建无菜单应用
    demandDialog: false, // 需求
    wxworkIntroDialog: false, // 需求
    payTipDialog: false,//付费
    bindMobileDialog: false,//绑定手机
    // dataReportDialog: false,//数据上报
    customDialog: false, //自定义弹窗
    licenseRemindDialog: window.TEAMS?.licenseRemindDialog // license到期提醒弹框
  };
  @observable licenseRemindDays: number = 1; // license到期提醒天数
  @observable customDialogParams: CustomDialogParams = new CustomDialogParams();  //自定义弹窗参数
  @observable mainParentPath: string = '';
  @observable createDialogModule: string = '';
  @observable createDialogFormId: any = '';
  @observable asideMenuComProps: any = {}; //左侧菜单组件配置
  @observable asideMenuForceRender: boolean = false;
  @observable asideInitialConfigs: any = {}//lib传入的初始菜单配置
  asideCusMenuData: any = undefined; //左侧菜单新
  asideMenuData: any = []; //左侧菜单
  @observable asideMenuDataKey: string = "";
  @observable asideDraftMenuList: any = []; //左侧一级菜单设置项
  @observable asideMenuConfig: any = {};//左侧菜单全部配置
  @observable asideMenuValue: string = ""; //左侧菜单选中受控
  @observable asideHidden: boolean = false; //默认展开侧边栏
  @observable asideMenuExpandKeys: any = []; //左侧菜单展开受控
  @observable asideMenuPrefix: any = null; //菜单顶部内容
  @observable asideMenuSuffix: any = null; //菜单底部内容
  @observable asideMenuDelay: boolean = false;
  @observable imTabContentVisible: boolean = false;//显示im内容
  @observable imTabMenuVisible: boolean = false;
  @observable imCounter: any = 0;
  @observable moduleCanLoad = false;//部分模块延迟加载
  @observable redirectRoutesData: any = [];
  asideOriMenuData: any = [];
  asideMenuDataMap: any = {}; //左侧菜单map 方便获取菜单配置
  asidePathWithIdMap: any = {}; //左侧菜单 path和id 的映射map
  routeTo: any;
  beforeUpdateAsideMenus: any;
  emSetActiveWeb: any;
  beforeUpdateMenus: any;
  // @observable settingList: settingListType[] = []; // 子菜单配置
  // @observable settingDraftList: settingListType[] = []; // 子菜单配置草稿
  @observable settingDialogVisible: boolean = false; // 菜单设置展示

  @observable inviteWelfareInfo: any = {}; // 推荐福利
  @observable inviteTeams: any = {}; // 推荐详情列表

  @observable iframeSrc: string = ''; // iframe嵌入地址

  @observable currentMoule: string = '';//当前的模块key
  @observable sideMenuMoule: string = '';//当前左侧菜单模块key
  @observable moduleContent: any = '';//主体内容
  @observable countTabValues: any = {};//事项统计数据
  @observable docPortalDetailShow: boolean = false;
  @observable layoutLoginShown = !!window.showLayoutLogin;
  @observable qysCheckAuthUrl: string = '';
  @observable qysDialogShown: boolean = false;

  // @observable layoutLoginShown = true;
  @observable hiddenAsideByCustomTheme: boolean = false;//特色主题下是否隐藏左侧菜单
  @observable subMixMenus: any = undefined;//混合布局模式下悬浮菜单
  @observable mixMenus: any = undefined;//混合布局模式下混合菜单
  @observable isCusappAsideHiddenByMode: boolean = false;//是否样式隐藏左侧菜单
  @observable themeMenuType='regular'; //特色主题菜单类型，混合｜常规

  //企业微信终端
  @observable clientDownloadUrls = [] as any

  @observable customRouteMenus = [] as RootLayoutMenuData[] //自定义菜单路由映射数据

  //是否他人空间
  @observable isOtherUser = false;
  @observable isOldVersion = window.location.pathname.indexOf("eworkspace_") === -1; //是否老版本下属空间
  @observable otherUserPermission = { isSub: true, isFollow: true, permission: true };  //是否有他人空间查看权限

  //主题插件
  @observable themePlugins: PcThemePluginData[] = [];

  @observable asideWidth = 200; //侧边栏宽度

  //平铺更多应用显示
  @observable moreAppTilingPageShow = false;

  //特色主题支持
  @observable toPortal: () => void = () => { }//跳转至门户方法
  @observable showImContent: () => void = () => { }//im消息打开方法
  @observable quickLogout: () => void = () => { }//退出登录方法
  @observable quickMenuClick: (data: NavMenuItem) => void = (data) => { }//退出登录方法
  @observable getMoreAppShowType: (data: NavMenuItem) => void = (data) => { }//获取更多应用打开方式
  @observable getRootLayoutProps: () => void = () => { }//rootlayout参数获取

  //客户端状态
  @observable clientWindowsFullscreen = false;
  @observable disableDrag = false;
  @observable imSilent = false;  //静默模式
  @observable imEnable = !localStorage.getItem("__test_im_enable");  //im工作消息显示状态

  // license提醒天数
  @observable licenseExpirationDate = window.TEAMS?.licenseExpirationDate || 15;

  //pc锁定状态
  @observable pcLocked = window.TEAMS?.pageLockInfo?.lockStatus === "LOCK";

  //新菜单数据(无数据时控制菜单隐藏)
  @observable asideMenuDataNew = []

  // 当前打开快捷新建菜单
  @observable quickMenu = {} as any;

  //外部联系人身份列表
  @observable externalEmployeesList: Array<OuterIdentityItem> = []

  //允许前台设置应用设置
  @observable allowEmpSetting: boolean = true;

  //工作消息显示位置
  @observable workMsgType: "navigation" | "dangling" = "navigation";

  //更多应用平铺方式
  @observable moreAppType: "floatmenu" | "tilingpage" = "floatmenu";

  // 门户是否启用
  @observable patalEnabled: boolean = true;

  @action
  changeLayoutLoginShown = (value: boolean) => {
    window.showLayoutLogin = value;
    this.layoutLoginShown = value;
  }
  @action
  changeImTabMenuVisible = (visible: boolean) => {
    this.imTabMenuVisible = visible;
  }
  @action
  changeModuleCanLoad = (value: boolean) => {
    this.moduleCanLoad = value;
  }

  /////////////////////////////
  //特色主题相关方法支持
  @action
  setToPortal = (fc: () => void) => {//门户跳转方法
    this.toPortal = fc;
  }
  @action
  setShowImContent = (fc: () => void) => {//显示IM消息内容方法
    this.showImContent = fc;
  }
  @action
  setQuickLogout = (fc: () => void) => {//退出登录方法
    this.quickLogout = fc;
  }
  @action
  setQuickMenuClick = (fc: (data: NavMenuItem) => void) => {//右侧菜单点击方法
    this.quickMenuClick = fc;
  }
  @action
  setGetMoreAppShowType = (fc: (data: NavMenuItem) => void) => {//获取更多应用菜单打开方式
    this.getMoreAppShowType = fc;
  }
  @action
  setGetRootLayoutProps = (fc: () => void) => {//获取rootlayout参数获取方法
    this.getRootLayoutProps = fc;
  }
  getImShowOnNavigation = (item?: NavMenuItem) => {//特色主题im消息权限展示
    if(!item){
      item = headerMenuStore.navMainMenus.find((item) => item.menuKey === 'quick_work_message')
    }
    const userConfig = window.TEAMS?.userConfig;
    const teamsConfig = { ...item };
    //应用使用范围无人员权限提示
    let imTabMenuVisible = false;
    const personConfig = inPCClient() ? userConfig?.['message.display.client'] : userConfig?.['message.display.web']; //navigation   dangling
    if (needShowEm()) {
      if (this.isOtherUser) {
        imTabMenuVisible = false;
      }

      if (personConfig && teamsConfig?.allowUserChange === 1) {
        imTabMenuVisible = personConfig === "navigation";
      } else if (teamsConfig) {
        imTabMenuVisible = teamsConfig?.showWay === ShowWays.MAIN_MENU;
      }
    }
    return imTabMenuVisible;
  }
  //////////////////////////

  @action
  changeImTabContentVisible = (visible: boolean) => {
    this.imTabContentVisible = visible;
    if (visible) {
      setTitle({
        title: window.weappLayout?.layoutTitle || `${getLabel('97028', '工作消息')} - ${window.TEAMS?.currentTenant?.tenantName}`
      });
    } else {
      setBrowserTitle();
    }
    window.weappEm?.setActiveWeb?.({
      activeWeb: visible,
      success: (res: any) => {
      },
      fail: (error: any) => {
      }
    });
  }
  // 更新im未读数
  @action
  changeImCounter = (value: any) => {
    if (!isNaN(value)) {
      // if (value > 99) {
      //   value = '99+'
      // }
      this.imCounter = value;
    }
  }

  @action
  openCreateDialog = (menu: any) => {
    this.quickMenu = menu;
  };

  @action
  changeCreateDialogModule = (module: string, formId: any) => {
    this.mainParentPath = window.location.pathname.replace(/\/$/, () => '');
    this.createDialogModule = module;
    this.createDialogFormId = formId;
  };

  @action
  updateModuleContent = (content: ReactNode | string) => {
    if (content) {
      this.moduleContent = content;
    }
  }

  @action
  changeQysDialogShown = (visible: boolean) => {
    this.qysDialogShown = visible;
  }

  @action
  changeQysCheckAuthUrl = (value: string) => {
    this.qysCheckAuthUrl = value;
  }

  @action
  clearQysQrcode = () => {
    clearInterval(headerTenantStore.qysTimer);
    this.qysDialogShown = false;
    this.qysCheckAuthUrl = '';
  }
  // 切换团队
  @action
  changeTeam = (tenant: any) => {
    headerTenantStore.changeTeam(tenant)
  }
  @action
  init = (routeEv: any) => {
    this.routeTo = routeEv;

    // 测试重定向数据,随模块变化清空再赋值
    // this.redirectRoutesData = [{
    //   from: `/task`,
    //   to: `/task/list/${window.TEAMS?.currentUser?.id}/mine`
    // }, {
    //   from: `/task/xxxxx`,
    //   to: `/task/list/${window.TEAMS?.currentUser?.id}/mine`
    // }];
    if (navNeedShow()) {
      headerMenuStore.init(); //初始化导航菜单
    }
    this.setDefaultLang();
    const time = 5 * 60 * 1000;
    //轮询登录时长
    if (!isProductEnv()) {
      setInterval(() => {
        mainAPI.loginTimeCheck().then((result: any) => {
          // console.log(result);
        })
      }, time)
    }
  };

  @action
  loadIm = (() => {
    let _util: any = null, _ignoreSysSetting: boolean | undefined;
    return (callback?: (emUtil: any) => void, ignoreSysSetting?: boolean) => {
      if (ignoreSysSetting !== undefined) { //固定浮动显示
        _ignoreSysSetting = ignoreSysSetting;
      }
      const isSdkCall = ignoreSysSetting !== undefined;   //从sdk调用过来
      try {
        const initEm = (em: any) => {
          em?.unreadCountListener?.({
            callback: (unread: number) => {
              let timer = setTimeout(() => {
                this.changeImCounter(unread);
                clearTimeout(timer)
              }, 50)
            }
          });
          em?.hasLoginListener?.({
            callback: (isOk: boolean) => {
              if (!isOk) {
                this.changeImTabMenuVisible(false);
                this.changeImTabContentVisible(false);
              }
            }
          });
          let emBtnDom: any = null, emBtnInit = false, emNavInit = false;
          const emUtil = {
            changeEmShowType: (type: 'nav' | 'btn') => {
              if (!needShowEm()){
                return;
              }
              if (isSdkCall || !_ignoreSysSetting) {
                if (type === 'btn') {
                  if (this.imTabMenuVisible) {
                    this.changeImTabMenuVisible(false);
                  }
                  if (this.imTabContentVisible) {
                    this.changeImTabContentVisible(false);
                  }
                  em?.setActiveWeb?.({
                    activeWeb: false
                  });
                  emUtil.initEmBtn();
                } else {
                  if (!this.imSilent) {
                    emUtil.initEmNav();
                  }
                  this.changeImTabMenuVisible(true);
                }
              }
            },
            initEmBtn: (callback?: Function) => {
              em?.addEmWebBtn?.({ needRefresh: true }, () => {
                emBtnInit = true;
                emBtnDom = document.querySelector("#weapp-em")
                callback?.(emBtnDom);
              })
            },
            initEmNav: () => {
              const dom = document.getElementById('emContainerDiv');
              em?.addEmWebBtn?.({ dom, needRefresh: emNavInit }, () => {
                try {
                  emNavInit = true;
                  //默认选中em时
                  if (this.imTabContentVisible) {
                    em?.setActiveWeb?.({
                      activeWeb: true
                    });
                  }
                } catch (e) {
                  console.info(e);
                }
              })
            }
          };
          return emUtil;
        }

        if (!window.emModuleLIbLoaded && isShowEMByUrl()) {
          corsImport(`@weapp/em`).then(em => {
            const util = initEm(em);
            _util = util;
            callback?.(util);
          })
          window.emModuleLIbLoaded = true;
        }
      } catch (error) {
        console.error(error);
      }
    }
  })()

  @action
  initIm = (callback?: (emUtil: any) => void) => {
    let { navMainMenus } = headerMenuStore;
    const userConfig = window.TEAMS?.userConfig;

    //预览模式用预览数据替换主导航配置
    if (isPreviewToolMenu()) {
      try {
        const previewData = window.parent?.previewData?.toolMenu;
        navMainMenus = previewData.navMainMenus;
      } catch (e) {
      }
    }

    //应用使用范围无人员权限提示
    let imTabMenuVisible = false;

    const teamsConfig = navMainMenus.find((item) => item.menuKey === "quick_work_message");
    const personConfig = inPCClient() ? userConfig?.['message.display.client'] : userConfig?.['message.display.web']; //navigation   dangling

    if (needShowEm()) {
      if (personConfig && teamsConfig?.allowUserChange === 1) {
        imTabMenuVisible = personConfig === "navigation";
      } else if (teamsConfig) {
        imTabMenuVisible = teamsConfig?.showWay === ShowWays.MAIN_MENU;
      }
      if (this.isOtherUser) {
        imTabMenuVisible = false;
      }

      if (isPreviewToolMenu()) {
        this.changeImTabMenuVisible(imTabMenuVisible);
      } else {

        //工作消息加载延时
        const floatDelayTime = window.ecode_emFloatDelayTime || 1000;
        const navDelayTime = window.ecode_emNavDelayTime || 0;
        const imDelayTime = imTabMenuVisible ? navDelayTime : floatDelayTime;

        let timer = setTimeout(() => {
          this.loadIm((emUtil) => {
            if (imTabMenuVisible) {
              emUtil.changeEmShowType('nav');
            } else {
              emUtil.changeEmShowType('btn');
            }
            callback?.(emUtil)
          })
          clearTimeout(timer)
        }, imDelayTime)
      }
    }
  }
  @action
  updateCusappAsideHiddenByMode = (value: boolean) => {//cusapp 左侧菜单所有节点不展示处理
    this.isCusappAsideHiddenByMode = !!value;
  }
  @action
  changeThemeMenuType=(type:string)=>{//更新特色主题菜单类型，混合｜常规
   this.themeMenuType=type||'regular';
  }
  @action
  addEcodeEV = (type: string, ev: any) => {
    switch (type) {
      case 'asideMenu':
        this.beforeUpdateAsideMenus = ev;
        break;
      case 'appMenu':
        headerMenuStore.beforeUpdateAppMenus = ev;
        break;
      case "appAllMenu":
        headerMenuStore.beforeUpdateAppAllMenus = ev;
        break;
      case 'createMenu':
        headerMenuStore.beforeUpdateFastCreateMenus = ev;
        break;
      case 'quickMenu':
        headerMenuStore.beforeUpdateQuickMenus = ev;
    }
  };
  setRedirectRoutesData = (triggerRoutes: [], targetRoute: string) => {
    const data = triggerRoutes.map((originRoute) => {
      return {
        from: `${layoutPublicUrl}${originRoute}`,
        to: `${layoutPublicUrl}${targetRoute}`
      }
    })
    this.redirectRoutesData = [...data];
  }
  /* 变更导航布局方向 */
  @action
  changeLayout = (value?: LayoutModes, notSave?: boolean) => {
    if (!value) {
      value = this.layoutMode === 'v' ? 'h' : 'v';
    }
    this.layoutMode = value;
    //更新TEAMS
    if (!notSave && window.TEAMS?.theme?.layout) {
      window.TEAMS.theme.layout = value;
    }

    if (value === 'hSuspend' && !this.subMixMenus) {//混合悬浮布局获取菜单数据
      this.getAllMenusByMix();
    }

    setNav();
    if (!notSave) {
      this.saveLayout();
    }
  };
  @action
  saveLayout = () => {
    mainAPI.setNav({ 'configKey': 'system.layout', 'configValue': this.layoutMode })
      .then((data: any) => {
        runInAction(() => {
          console.log(data);
          if (data) {
            message({
              type: "success",
              content: getLabel('22009', '修改成功'),
            });
          }
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  @action
  checkLeftMenuExternalData = () => {
    if (this.beforeUpdateAsideMenus) {
      this.updateAside([]);
    }
  }

  @action
  saveHistoryMenu = (path: string) => {
    if (headerMenuStore.isOtherUser) return;
    if (path.indexOf('/splayout') !== -1) {
      path = path.replace('/splayout', '');
    }
    mainAPI.saveUserConfig({ 'configKey': 'system.menu.display', 'configValue': path })
      .then((data: any) => {
        // runInAction(() => {
        console.log(data);
        // if (data) {
        //   message({
        //     type: "success",
        //     content: getLabel('22009', '修改成功'),
        //   });
        // }
        // });
      })
      .catch((error: any) => {
        console.log(error);
      });
  };


  @action
  saveHistoryMenuOpenMode = (openMode: string) => {
    mainAPI.saveUserConfig({ 'configKey': 'system.menu.openMode', 'configValue': openMode });
  };

  /* 框架各个弹框显示控制 */
  @action
  changeDialogVisible = (dialog: HeaderDialogNames, visible: boolean) => {
    this.dialogsVisible[dialog] = visible;
  };

  @action
  refreshEmployee = () => {
    const empId = window.TEAMS.currentUser.id;
    const tenantKey = window.TEAMS.currentTenant.tenantKey;
    mainAPI.refreshEmployee(empId, tenantKey)
      .then((data: any) => {
        console.log(data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  @action
  checkDocPopDetails = () => {
    if (sessionStorage.getItem('WEAPP_LAYOUT_DOC_DETAILSPOP')) {
      return;
    }
    mainAPI.getPopupDocumentIds()
      .then((data: any) => {
        if (data.data?.docIds && data.data.docIds.length > 0) {
          runInAction(() => {
            this.docPortalDetailShow = true;
          })
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
    sessionStorage.setItem('WEAPP_LAYOUT_DOC_DETAILSPOP', '1');
  };

  @action
  updateAsideMenuConfig = (config: object) => {
    this.asideMenuConfig = {
      ...config,
      ...this.asideMenuConfig
    }
  }
  @action
  updateAsideMenuNew = (data: any) => {//新菜单数据存储
    if (!isEqual(data, toJS(this.asideMenuDataNew))) {
      this.asideMenuDataNew = data || [];
    }
  }


  /* 左侧菜单更新 */
  // TODO 参数强类型约束
  @action
  updateAsideMenuMap = (list: Array<any>, isSp = false) => {
    const needCopy: boolean = !!(this.sideMenuMoule && this.sideMenuMoule.indexOf('crm/') !== -1);
    const formatData = formatMenuData(list, isSp, needCopy);
    this.asideMenuData = formatData.list;
    this.asideMenuDataKey = `key_${new Date().getTime()}`
    this.asideMenuDataMap = formatData.map;
    this.asidePathWithIdMap = formatData.pathIdMap;
    // if (!isCusapp()) {
    updateMenuInfoData('asideMenusData', formatData.list);//更新sdk中的左侧菜单
    // }
  };

  @action
  updateAllSdkMenuInit = () => {//隐藏时初始触发一次
    updateMenuInfoData('navAppMenusData', toJS(headerMenuStore.activeShowMenus));//更新sdk中的导航显示菜单
    updateMenuInfoData('allAppMenusData', headerMenuStore.allAppMenus);//更新sdk中的更多应用菜单
  }
  /* 更新当前module值 */
  @action
  updateCurrentMoule = (key: string) => {
    this.currentMoule = key;
  };

  @action
  updateAsideMenuComProps = (obj: any) => {
    this.asideMenuComProps = { ...obj };
  }

  @action
  changeAsideMenuValue = (v: string) => {
    this.asideMenuValue = v;
    const menuItem = this.asideMenuDataMap[v];
    window.layoutActiveMenuInfo = { module: this.currentMoule, menuId: v, menuInfo: menuItem }
    if (menuItem) {
      this.setIframeSrc(menuItem.iframeSrc || '');
    }
    updateMenuInfoData('asideMenuActiveKey', menuItem);//更新sdk中的选中菜单
  };

  @action
  changeAsideExpandKeys = (list: Array<any>, forceReplace?: boolean) => {
    let asideMenuExpandKeys = toJS(this.asideMenuExpandKeys);
    if (forceReplace) {
      this.asideMenuExpandKeys = list;
      return;
    }
    if (Array.isArray(asideMenuExpandKeys) && asideMenuExpandKeys.length > 0) {
      list.forEach((item: any) => {
        if (!asideMenuExpandKeys.includes(item)) {
          asideMenuExpandKeys.push(item);
        }
      })
      this.asideMenuExpandKeys = [...asideMenuExpandKeys];
    } else {
      this.asideMenuExpandKeys = list;
    }
    updateMenuInfoData('asideMenuExpandKeys', toJS(this.asideMenuExpandKeys));//更新sdk中的菜单展开
    this.updateAsideDataExpand();
  };
  @action
  updateAsideDataExpand = () => {
    if (this.asideMenuConfig.leftMenus) {
      this.asideMenuConfig.expandChild = false;
      this.asideMenuConfig.leftMenus.forEach((menu: any) => {
        menu.expendChild = !!this.asideMenuExpandKeys.includes(menu.id);
      })
    }
  }

  @action
  changeAsideExpandKeysById = (v: any) => {
    const menuItem = this.asideMenuDataMap[v];
    if (menuItem && menuItem.parentIds) {
      this.changeAsideExpandKeys(menuItem.parentIds);
    }
  };

  @action
  getInviteRuleInfo = () => {
    InviteWelfareAPI.getInviteWelfare()
      .then((result: any) => {
        runInAction(() => {
          this.inviteWelfareInfo = result;
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  @action
  getInviteTeams = (formData: FormData) => {
    InviteWelfareAPI.getInviteTeams(formData)
      .then((result: any) => {
        runInAction(() => {
          this.inviteTeams = result;
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  @action
  updateAside = (menuList: any, isSp = false, resetAvailable: boolean = true, checkRoute: boolean = false, fromEE = false) => {
    isSp = needLayout();

    if (Array.isArray(menuList)) {
      if (this.asideMenuConfig?.leftMenus && fromEE) {
        this.asideMenuConfig.leftMenus = menuList;
      }
      if (this.beforeUpdateAsideMenus) {//ecode
        menuList = this.beforeUpdateAsideMenus(menuList);
      }
      if (resetAvailable) {
        // this.asideAvailable = menuList && menuList.length > 0; //是否显示侧边菜单
        this.setAsideAvailable(menuList && menuList.length > 0)
      }
      let expendKey: any = [];
      // 全部展开
      if (this.asideMenuConfig.expandChild) {
        menuList.forEach((menu: any) => {
          if (menu.children && Array.isArray(menu.children) && menu.children.length > 0 && menu.id) {
            expendKey.push(menu.id);
          }
        })

      } else {
        // 按个菜单设置展开
        menuList.forEach((menu: any) => {
          if (menu.expandChild) {
            expendKey.push(menu.id);
          }
        })
      }
      // if (this.asideMenuExpandKeys.length === 0) {
      this.changeAsideExpandKeys(expendKey);
      // }

      if (this.isOtherUser) {
        const replacePath = (menuItem: any) => {
          //下属空间商机path一致  兼容
          if (menuItem?.path?.indexOf("/saleChance") !== -1) {
            menuItem.path = menuItem?.path?.replaceAll?.('/saleChance', '/salechance');
          }

          //新版本他人空间url需要加上eworkspace标识
          if (!mainStore.isOldVersion) {
            if (menuItem.path && menuItem.path.indexOf("eworkspace_") === -1) {
              menuItem.path = menuItem.path.replaceAll(headerMenuStore.otherUserInfo.id, `eworkspace_${headerMenuStore.otherUserInfo.id}`)
            }
          }
        }
        menuList.forEach((item: any) => {
          replacePath(item);
          if (item.children) {
            item.children.forEach((child: any) => {
              replacePath(child);
            })
          }
        })
      }

      this.updateAsideMenuMap(menuList, isSp);
      this.updateAsideActiveMenu(() => {
        if (this.asideInitialConfigs.autoTriggerRoute && checkRoute
          && this.asideInitialConfigs.autoTriggerRoute.includes(window.location.pathname.replace(layoutPublicUrl, ''))) {
          //这里目前场景就两级，暂时不递归处理
          for (let i = 0; i < menuList.length; i++) {
            if (menuList[i].path && menuList[i].status) {
              this.routeTo(menuList[i].path);
              this.setRedirectRoutesData(this.asideInitialConfigs.autoTriggerRoute, menuList[i].path);
              break;
            } else {
              let ifBreak = false;
              if (menuList[i].children) {
                let child = menuList[i].children;
                for (let k = 0; k < child.length; i++) {
                  if (child[k].path && child[k].status) {
                    this.setRedirectRoutesData(this.asideInitialConfigs.autoTriggerRoute, child[k].path);
                    ifBreak = true;
                    break;
                  }
                }
              }
              if (ifBreak) break
            }
          }
        }
      });

    } else {
      this.asideOriMenuData = [];
      this.asideMenuConfig = {};
      this.updateAsideMenuMap([]);
      this.asideMenuExpandKeys = [];
      this.sideMenuMoule = '';
      this.updateAsideMenuComProps({});
      if (resetAvailable) {
        this.setAsideAvailable(false);
        // this.asideAvailable = false;
      }

    }
    //resize页面，触发个别页面图表重绘
    if (window.location.pathname.indexOf('/hrm') !== 0) {
      doResize();
    }

  };

  updateAsideActiveMenu = (callback?: any) => {
    if (this.asideMenuData) {

      // 根据路由选中左侧菜单
      let menuId = this.asidePathWithIdMap[window.location.pathname.replace(layoutPublicUrl, '')];
      if (!menuId) {
        let matchLength = 0; //匹配字符长度
        for (let key in this.asidePathWithIdMap) {

          if (window.location.href.indexOf(key) !== -1 && key.length > matchLength) { //匹配字符长度最长的路由
            matchLength = key.length;
            //路由逐级匹配
            let menuArr = key.split('/').filter((it) => it !== ''),
              pathArr = window.location.pathname.split('/').filter((it) => it !== ''),
              flag = true;
            menuArr.forEach((it, index) => {
              if (!pathArr[index] || it !== pathArr[index]) {
                flag = false;
              }
            })
            if (flag) {
              menuId = this.asidePathWithIdMap[key];
            }
          }
        }
      }

      if (!menuId) {

        const matchMenu: any = Object.values(this.asideMenuDataMap).find((item: any) => {
          if (item.pathReg) {
            return new RegExp(item.pathReg).test(window.location.href);
          }
          return false;
        });
        if (matchMenu) {
          menuId = matchMenu.id;
        } else {
          callback && callback();
        }
      }

      if (menuId) {
        this.changeAsideMenuValue(menuId);
        const menuItem = this.asideMenuDataMap[menuId];
        if (menuItem && menuItem.parentIds) {
          this.changeAsideExpandKeys(menuItem.parentIds);
        }
      }
    }
  }

  /**
    * 更新菜单设置
    * @param props getMenuSettingParams
    */
  @action
  updateAsideDraftMenuList = (menuList: any) => {
    this.asideDraftMenuList = menuList;
  };
  @action
  restAsideDraftMenuList = () => {
    if (this.asideOriMenuData?.length) {
      const asideDraftMenuList = this.asideOriMenuData.find((menu: any) => menu.canSetting)?.children || [];
      this.asideDraftMenuList = [...(asideDraftMenuList)];//作为设置菜单选项草稿
    }

  };
  /**
    * 更新菜单设置
    * @param props getMenuSettingParams
    */
  @action
  saveAsideMenu = () => {
    const asideDraftMenuList = toJS(this.asideDraftMenuList).filter((item: any) => item.content !== '')
    const findCanSettingMenusIndex = this.asideMenuConfig.leftMenus.findIndex((menu: any) => menu.canSetting);
    this.asideMenuConfig.leftMenus[findCanSettingMenusIndex].children = asideDraftMenuList;
    mainAPI.saveLeftMenus(this.sideMenuMoule, toJS(this.asideMenuConfig)).then((data) => {
      runInAction(() => {
        if (data.data && data.data.leftMenus)
          this.updateAsideData(data.data, true);
        if (!headerMenuStore.otherUserInfo?.id && window.localStorage) {
          window.localStorage.setItem(`leftmenu_${this.sideMenuMoule}_${window.TEAMS?.currentUser.id}`, JSON.stringify(data.data));
        }
        if (data.code === 200) {
          message({
            type: 'success',
            content: getLabel('16291', '操作成功')
          });
        }
        if (this.currentMoule === 'formreport') {
          if (data.code === 100) {
            message({
              type: 'error',
              content: data.msg
            });
          }
        }
      })
    })
  };
  /**
    * 初始化菜单设置
    * @param props getMenuSettingParams
    */
  @action
  initAsideMenu = () => {
    mainAPI.initLeftMenus(this.sideMenuMoule).then((data) => {
      runInAction(() => {
        if (data.data && data.data.leftMenus)
          this.updateAsideData(data.data, true);
        if (!headerMenuStore.otherUserInfo?.id && window.localStorage) {
          window.localStorage.setItem(`leftmenu_${this.sideMenuMoule}_${window.TEAMS?.currentUser.id}`, JSON.stringify(data.data));
        }
        message({
          type: 'success', // type: 'info', 'error', 'success'
          content: getLabel('16291', '操作成功')
        });
      })
    })
  };

  @action
  initAsideByConfig = (menuConfig: any) => {
    let ebUseCatch;
    if (menuConfig === 'reload') {
      ebUseCatch = false;
      menuConfig = toJS(this.asideInitialConfigs);
    } else {
      this.asideInitialConfigs = menuConfig;
    }
    // 更新menu组件额外(组件库的<Menu>，不指左侧菜单)配置,目前无需求
    if (menuConfig.menuProps) {
      this.updateAsideMenuComProps(menuConfig.menuProps);
    } else {
      this.updateAsideMenuComProps({})
    }

    //模块传入的菜单数据
    if (menuConfig.getMenus) {
      menuConfig.getMenus(ebUseCatch).then((result: any) => {
        const delayTimer = setTimeout(() => {
          if (result.data) {
            //更新整个左侧菜单
            this.updateAsideData(result.data);
          }
          clearTimeout(delayTimer);
        }, 0);
      });
      if (menuConfig?.module) {
        this.sideMenuMoule = menuConfig.module;
      }
    } else {
      //根据module走主框架统一请求菜单
      this.getAsideMenu(menuConfig);
    }
  }

  @action
  getAllModuleMenus = () => {
    mainAPI.getAllModuleMenus().then((data) => {
      runInAction(() => {
        console.log(data);
      })
    })
  }
  @action
  changeAsideInitialConfigs = (configs: any) => {
    this.asideInitialConfigs = configs;
  };

  /**
    * 控制菜单设置显隐
    * @param props changeSettingDialogVisible
    */
  @action
  changeSettingDialogVisible = (visible: boolean) => {
    this.settingDialogVisible = visible;
  };


  @action
  setIframeSrc = (src: any) => {
    this.iframeSrc = src;
  }

  @action
  setAsideAvailable = (value: boolean) => {
    this.asideAvailable = value;
  }


  @action
  changeAsideVisible = (hidden: boolean) => {
    this.asideHidden = hidden;
    if (this.asideInitialConfigs?.onAsideVisibleChange) {
      this.asideInitialConfigs.onAsideVisibleChange(!hidden);
    }
  }
  @action
  updateAsideInitialConfigs = (params: any) => {
    this.asideInitialConfigs = {
      ...this.asideInitialConfigs,
      ...params
    }
  };
  // @action
  // updateAsidePrefix = (prefix: ReactNode) => {
  //   this.asideMenuPrefix = prefix;
  // }
  // @action
  // updateAsideSuffix = (suffix: ReactNode) => {
  //   this.asideMenuSuffix = suffix;
  // }
  @action
  getAsideMenu = (menuConfig?: any) => {
    if (typeof menuConfig === 'string') {
      this.sideMenuMoule = menuConfig;
    } else if (menuConfig?.module) {
      this.sideMenuMoule = menuConfig.module;
    }
    let userId = window.TEAMS?.currentUser?.id;
    let checkRoute = false;

    if (headerMenuStore.otherUserInfo.id) {
      userId = headerMenuStore.otherUserInfo.id;
    }
    //需要自动触发路由的模块走本地缓存的也触发路由
    if (menuConfig.autoTriggerRoute) {
      checkRoute = true;
    }
    if (menuConfig?.needCover) {
      //暂时阻止显示
      this.asideMenuDelay = true;
    }
    if (!menuConfig?.needCover) {
      this.useCacheDataUpdate(checkRoute); //先使用缓存渲染一次
    }
    const queryModule = this.sideMenuMoule;
    if (!queryModule) {
      this.useCacheDataUpdate(true); //check route
      return
    }
    mainAPI.queryLeftMenus(queryModule, userId).then((data: any) => {
      if (queryModule !== this.sideMenuMoule) {
        return;
      }
      if (data.data && data.data.leftMenus) {
        // 下属空间不缓存
        runInAction(() => {
          //已有缓存默认已经触发过路由
          if (window.localStorage.getItem(`leftmenu_${this.sideMenuMoule}_${userId}`) && !this.asideMenuDelay) {
            this.updateAsideData(data.data, false);
          } else {
            this.updateAsideData(data.data, true);
          }
          if (!headerMenuStore.otherUserInfo.id && window.localStorage) {
            window.localStorage.setItem(`leftmenu_${this.sideMenuMoule}_${userId}`, JSON.stringify(data.data));
          }
        });
      } else {
        // 缓存兜底数据
        this.useCacheDataUpdate(true); //check route
      }
      if (this.asideInitialConfigs?.onLeftMenuLoaded && typeof (this.asideInitialConfigs.onLeftMenuLoaded) === 'function') {
        let timer = setTimeout(() => {
          // this.asideMenuDelay = false;
          this.asideInitialConfigs.onLeftMenuLoaded(data);
          clearTimeout(timer);
        }, 300);
      }
    }).catch((error: any) => {
      // 后面改成只触发一次路由
      this.useCacheDataUpdate(true); //check route
      console.log(error);
    });
  }
  @action
  changeAsideMenuDelay = (isDelay: boolean) => {
    this.asideMenuDelay = isDelay;
  }

  // 尝试使用缓存数据
  @action
  useCacheDataUpdate = (checkRoute: boolean = false) => {
    let userId = window.TEAMS?.currentUser.id;
    const data = window.localStorage.getItem(`leftmenu_${this.sideMenuMoule}_${userId}`);
    if (data && data != 'undefined' && !headerMenuStore?.otherUserInfo?.id) {
      this.updateAsideData(JSON.parse(data), checkRoute);
    }
  }

  @action
  updateAsideData = (data: any, checkRoute: boolean = false) => {
    // data.canSetting = true;//测试
    this.asideMenuConfig = data;//所有配置
    if (data.show === false) {
      this.asideHidden = true;//折叠侧边栏
    } else {
      this.asideHidden = false;
    }
    if (data.leftMenus) {
      data.leftMenus = this.loopAsideMenu(data.leftMenus);
      this.asideOriMenuData = cloneObj(data.leftMenus);
    }
    // this.asideAvailable = true;//显示左侧菜单
    if (data.canSetting) {
      const asideDraftMenuList = (data.leftMenus || []).find((menu: any) => menu.canSetting)?.children || [];
      this.asideDraftMenuList = [...(asideDraftMenuList)];//作为设置菜单选项草稿
    }
    this.updateAside(data.leftMenus, false, true, checkRoute);//菜单映射
  }

  @action
  updateAsideByLocalConfig = (config: any) => {
    config.sideMenuMoule && (this.sideMenuMoule = config.sideMenuMoule);
    config.data && this.updateAsideData(config.data);
    config.expandKeys && this.changeAsideExpandKeys(config.expandKeys);
  }

  loopAsideMenu = (list: any) => {
    list = list.filter((item: any) => item.content !== '')
      .map((item: any) => {
        if (item.children) {
          item.children = this.loopAsideMenu(item.children);
        }
        return item;
      });
    return list;
  };

  @action
  updateAsideStatus = () => {
    if (this.asideMenuConfig.leftMenus) {
      this.updateAside(toJS(this.asideMenuConfig.leftMenus), false, true, true);//菜单映射
    } else {
      this.updateAsideActiveMenu();
    }
  }

  @action
  setDefaultLang = () => {
    const teams = window.TEAMS;
    if (teams && teams.currentUser && !teams.locale) {
      let browserLan: any = window.navigator.language;

      if (browserLan && browserLan.indexOf('zh-CN') !== -1) {
        browserLan = 'zh_CN';
      } else if (browserLan && browserLan.indexOf('zh-TW') !== -1) {
        browserLan = 'zh_TW';
      } else if (browserLan && browserLan.indexOf('en') !== -1) {
        browserLan = 'en_US';
      } else if (browserLan && browserLan.indexOf('es') !== -1) {
        browserLan = 'es_ES';
      } else if (browserLan && browserLan.indexOf('fr') !== -1) {
        browserLan = 'fr_FR';
      } else if (browserLan && browserLan.indexOf('pt') !== -1) {
        browserLan = 'pt_PT';
      } else if (browserLan && browserLan.indexOf('ar') !== -1) {
        browserLan = 'ar_AE';
      } else if (browserLan && browserLan.indexOf('ru') !== -1) {
        browserLan = 'ru_RU';
      } else if (browserLan && browserLan.indexOf('ja') !== -1) {
        browserLan = 'ja_JP';
      } else if (browserLan && browserLan.indexOf('de') !== -1) {
        browserLan = 'de_DE';
      } else if (browserLan && browserLan.indexOf('ko') !== -1) {
        browserLan = 'ko_KR';
      } else if (browserLan && browserLan.indexOf('th') !== -1) {
        browserLan = 'th_TH';
      } else {
        browserLan = 'zh_CN';
      }

      if (getCookie('langType')) {
        browserLan = getCookie('langType');
      }

      mainAPI.updateUserlang(browserLan);
    }
    //从passport来
    // if (teams.needUpdateLang) {
    //   mainAPI.updateUserlang(teams.loginAccountInfo?.language || 'zh_CN');
    // }

  }

  @action
  checkIsOtherUser = (callback: (is: boolean, userId?: string) => void, history: any) => {
    if (window.TEAMS?.eworkspace) {
      let userId = window.TEAMS?.eworkspace?.userId;
      if (userId !== window.TEAMS?.currentUser?.id) {

        //下属空间人力链接兼容
        const isUrlNewVersion = window.location.pathname.indexOf("/eworkspace_") !== -1;
        if (!isUrlNewVersion) {
          const planIndex = window.location.pathname.indexOf("/plan/list/")
          if (planIndex !== -1) {
            userId = window.location.pathname.substr(planIndex).split?.("/")[3]?.replaceAll("eworkspace_", "");
            window.TEAMS.eworkspace.userId = userId;
          }
          history.replace(window.location.pathname.replaceAll(`/${window.TEAMS.eworkspace.userId}`, `/eworkspace_${window.TEAMS.eworkspace.userId}`));
        }

        this.checkOtherUserIsAvailable(userId, (available) => {
          if (available) {
            mainAPI.queryOtherUserInfo(userId).then(({ status, data }) => {
              runInAction(() => {
                if (status) {
                  headerMenuStore.updateOtherUserInfo(data.user || data);
                  this.layoutMode = "h";  //他人空间固定横向导航
                  this.isOtherUser = true;
                  const hasCusappParams = !!window.location?.search;
                  if (!hasCusappParams && window.TEAMS?.eworkspace?.user) {
                    history.replace(window.location.pathname + `?subEmployeeId=${window.TEAMS?.eworkspace?.user.id}`)
                  }
                  callback(true, userId);
                } else {
                  callback(false, window.TEAMS?.currentUser?.id);
                }
              })
            })
          } else {
            this.isOtherUser = true;
            callback(true, userId);
          }
        })
      } else {
        history.replace(window.location.pathname.replace(/eworkspace_[\d]*/i, window.TEAMS?.currentUser.id))
        callback(false, userId);
      }
    } else {
      if (window.location.pathname.indexOf('/eworkspace_') !== -1) {
        if (window.location.pathname.indexOf("/workflow/list") !== -1) {
          history.replace(window.location.pathname.replace(/\/eworkspace_[\d]*/i, ""))
        } else {
          history.replace(window.location.pathname.replace(/eworkspace_[\d]*/i, window.TEAMS?.currentUser.id))
        }
        // modulesHomes.forEach((modulePath) => {
        //   if (window.location.pathname.indexOf(modulePath) !== -1){
        //     history.replace(window.location.pathname.split(modulePath)[0] + modulePath)
        //   }
        // })
      }
      callback(false);
    }
  }

  @action
  checkOtherUserIsAvailable = (userId: string, callback: (available: boolean) => void) => { //访问用户是否是当前用户的关注或者下属

    mainAPI.isFollowAndSub(userId).then(({ status, data, msg }) => {
      runInAction(() => {
        if (status) {
          const oldVersionApi = typeof data === "boolean";
          this.otherUserPermission = oldVersionApi ?
            { isSub: true, isFollow: true, permission: true } :
            { ...data, permission: data.isSub || data.isFollow };
          callback(oldVersionApi ? data : (data.isSub || data.isFollow));
        } else {
          message({ type: "error", content: msg })
        }
      })
    }).catch(() => {
      runInAction(() => {
        callback(false);
      })
    })
  }


  /**
  * 获取下属等单个人员信息
  * @param props saveMenuSettingParams
  */
  @action
  getOtherInfo = (id: string, userInfo: any) => {
    headerMenuStore.getOtherInfo(id, userInfo);
    if (this.asideInitialConfigs?.module) {
      this.getAsideMenu(this.asideInitialConfigs);
    }
  };

  /**
   * 添加logincount
   */
  @action
  addLoginCount = () => {
    mainAPI.addLoginCount().then((data: any) => {
      // if (data.data && data.data.leftMenus) {
      //   runInAction(() => {
      //     this.updateAsideData(data.data);
      //   });
      // }
    })
  }


  @action
  getAllMenusByMix = () => {//混合模式下获取所有二级菜单
    mainAPI.getAllModuleMenus()
      .then((result: any) => {
        runInAction(() => {
          if (result && result?.data) {
            console.log(result.data, "测试数据")
            this.subMixMenus = result.data;
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  @action
  getAllModuleMixedMenus = () => {//混合模式下获取所有二级菜单
    mainAPI.getAllModuleMixedMenus()
      .then((result: any) => {
        runInAction(() => {
          if (result && result?.data) {
            this.mixMenus = result.data;
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }


  /**
   * 超员状态
   */
  @action
  initPayTip = (appMenus?: any) => {
    let teamsPay = false;
    let appPay = false;
    let teamsPayTip = `${getLabel('84264', '您团队已超用户，请尽快联系我们的服务人员：')} 021-50388680`;
    let appPayTip = '';
    let adminStatus = [
      'outFreeUserInweek',
      'outPayUserInweek',
      'outPayTimeUserInweek'
    ], empStatus = [
      'outPayUserOutweek',
      'outPayTimeUserOutweek',
      'outFreeUserOutweek'
    ]
    //判断团队超员
    if (
      window.TEAMS?.currentTenant?.status &&
      ((adminStatus.includes(window.TEAMS.currentTenant.status) && window.TEAMS.currentUser?.admin) || empStatus.includes(window.TEAMS.currentTenant.status))
    ) {
      //团队超员
      teamsPay = true;
      // this.dialogsVisible.payTipDialog = true;
    }

    //应用超员判断
    if (!appMenus) {
      appMenus = toJS(headerMenuStore.allAppMenus);
    }
    // 当前module
    let curModule: any = '';
    let curMenu: any = null;
    let pathname = window.location.pathname.replace(layoutPublicUrl, '') || '/';
    if (pathname.indexOf('/portal') !== -1 || pathname === '/') {
      curModule = 'portal';
    } else {
      appMenus && appMenus.length > 0 && appMenus.forEach((colum: any) => {
        colum.forEach((group: any) => {
          group.menus && group.menus.forEach((menu: any) => {
            //捕获当前模块菜单数据
            if (window.location.pathname.indexOf(menu.path) !== -1 && menu.module !== 'freeUrl') {
              curModule = menu.module;
              curMenu = menu;
            }
          });
        });
      });
    }
    window.TEAMS?.modules && window.TEAMS?.modules.forEach((it: any) => {

      //非标准模块不处理
      if (it.module === curModule) {
        if (
          it.status &&
          ((adminStatus.includes(it.status) && window.TEAMS.currentUser?.admin) || empStatus.includes(it.status))
        ) {
          appPay = true;
          appPayTip = `${getLabel('84265', '您团队的')}"${curMenu?.menuname}"${getLabel('84266', '应用已超用户，请尽快联系我们的服务人员：')} 021-50388680`
        }
      }
    })

    const isExternal = window.TEAMS?.currentUser?.type === 'external';
    if (!isExternal){
      //应用超员
      if (appPay) {
        this.payTip = appPayTip;
        this.dialogsVisible.payTipDialog = true;
        return;
      }
      //团队超员仅在门户提示
      if (teamsPay && curModule === 'portal') {
        this.payTip = teamsPayTip;
        this.dialogsVisible.payTipDialog = true;
      }
    }
  }

  @action
  checkUserMobileBind = (callback?: Function) => {
    mainAPI.checkUserMobileBind().then((result: any) => {
      runInAction(() => {
        callback && callback(result.data);
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  @action
  getCountTabValues = () => {
    mainAPI.getCountTabValues().then((res) => {
      if (res.code === 200) {
        const { tag, watch, wait } = res.data
        runInAction(() => {
          this.countTabValues = {
            tag,
            watch,
            wait
          }
          // LayoutSDK.refreshNavMenuItemByMenuKey("quick_concern")
        })
      }
    })
  }
  @action
  updateHiddenAside = (value: any) => {
    this.hiddenAsideByCustomTheme = !!value;
    this.updateAllSdkMenuInit();
  }
  @action
  loadClientDownloadUrl = (callback?: Function) => {
    mainAPI.loadClientDownloadUrl().then(({ status, data, msg }) => {
      runInAction(() => {
        if (status) {
          this.clientDownloadUrls = data;
        }
        callback && callback();
      })
    }).catch(() => {
      callback && callback();
    })
  }

  @action
  loadPcPlugins = (callback: (data: PcThemePluginData[]) => void) => {
    mainAPI.getPcPluginList().then(({ status, msg, data }) => {
      runInAction(() => {
        if (status) {
          this.themePlugins = data.filter((item: any) => {
            return item.pluginStatus;
          });
          callback && callback(data);
        } else {
          message({ type: "error", content: msg });
        }
      })
    })
  }

  @action
  updateAsideWidth = (width: number) => {
    this.asideWidth = width;
  }

  @action
  updateOtherSpaceVersion = (isOld: boolean) => {
    this.isOldVersion = isOld;
  }
  @action
  updateRouteMenus = (data: RootLayoutMenuData[]) => {
    this.customRouteMenus = data || [];
  }

  @action
  updateMoreAppTilingPageShow = (show: boolean) => {
    this.moreAppTilingPageShow = show;
  }

  @action
  setCustomDialogAndShow = (params: CustomDialogParams) => {
    this.customDialogParams = { ...this.customDialogParams, ...params };
    this.changeDialogVisible("customDialog", true);
  }

  @action
  updateClientWindowsFullscreen = (is: boolean) => {
    this.clientWindowsFullscreen = is;
  }

  @action
  setDisableDrag = (disable: boolean) => {
    this.disableDrag = disable;
  }

  @action
  setImSilent = (enable: boolean) => {
    this.imSilent = enable;
    this.imTabContentVisible = false;
    if (enable) {
      // document.body.setAttribute('emhide', 'true')
    } else {
      document.body.setAttribute('emhide', 'false')
    }
  }

  @action
  setPCLocked = (lock: boolean) => {
    this.pcLocked = lock;
  }

  @action
  lockPage = (callback?: Function) => {
    LockAPI.lock(inPCClient()).then(({ status, data, msg }) => {
      if (status) {
      } else {
        message({ type: "error", content: msg });
      }
    })
  }

  @action
  changeImEnable = (enable: boolean) => {
    this.imEnable = enable;
  }


  //根据user_id和tenant_key查询外部联系人信息
  getExternalEmployees = async () => {
    const res = await queryExternalEmployees()
    runInAction(() => {
      this.externalEmployeesList = res?.data || []
    })
  }


  @action
  setMoreAppType = (type: any) => {
    runInAction(() => {
      this.moreAppType = type;
    })
  }

  @action
  loadDefaultOpenApp = () => {
    return new Promise((success, reject) => {
      Promise.all([AppAPI.queryEmpAppManageConfigs(), this.getNavMenuList()]).then(([res, res2]) => {
        if (res && res.data) {
          res.data.forEach((config: any) => {
            if (config.configKey === "allowEmpSetting") {
              runInAction(() => {
                this.allowEmpSetting = config.configValue !== '0';
              });
            } else if (config.configKey === "message.display.web") {
              runInAction(() => {
                this.workMsgType = config.configValue;
              });
            } else if (config.configKey === "moreapp.display.web") {
              runInAction(() => {
                this.moreAppType = config.configValue;
              })
            }
          })
        }
        success(res);
      })
    })
  }

  @action
  getNavMenuList = () => {
    return new Promise((success,reject) => {
      headerMenuStore.loadNavMenus((data: any) => {
        let mainMenus = data.MAIN_NAVI || [];
        const protalConfig = mainMenus.find((item: any) => item.menuKey === "quick_index");
        if (protalConfig && protalConfig.menuEnable) {
          runInAction(() => {
            this.patalEnabled = protalConfig.menuEnable == 1;
          })
        } else {
          runInAction(() => {
            this.patalEnabled = false;
          })
        }
        //本地缓存导航菜单
        try {
          localStorage.setItem(`LAYOUT_NAV_MENU_${window.TEAMS?.currentTenant?.tenantKey}_${window.TEAMS?.currentUser?.id}`, JSON.stringify(data));
        } catch (e) {
          //@ts-ignore
          if (e.name == 'QuotaExceededError' || e.name == 'NS_ERROR_DOM_QUOTA_REACHED') {
            window.ePassport?.showClearPrompt?.();
          }
        }
        success(data);
      })
    })
  }


  @action
  transAppManageDatas = () => {
    const appManageConfig = window.localStorage.getItem("transAppManageConfigs_"+ window.TEAMS?.currentUser?.id);
    if (appManageConfig !== "1") {
      try {
        const tEmd = mainAPI.transEmpMenusDisplay().then(() => {
          window.localStorage.setItem("transAppManageConfigs_"+ window.TEAMS?.currentUser?.id, "1");
        });
      } catch(error) {

      }
    }
  }

  @action
  licenseRemindCheck = () => {
    mainAPI.queryLicenseDiaRemind().then((result: any) => {
      const { data } = result;
      if (data) {
          const { remindable, remindDays } = data;
          runInAction(() => {
            this.dialogsVisible.licenseRemindDialog = remindable;
            this.licenseRemindDays = remindDays;
          });
      }
    }).catch((error) => {
        console.log(error)
    });
  }


}

let instance = new MainStore();

//TODO 火狐浏览器下特色主题偶现加载不出应用菜单-排除出是headerMenuStore初始化了两次，特色主题下的组件用了另一份store没有应用数据导致
const isSpecialTheme = window.TEAMS?.theme?.themeType === 'feature';
if (isFirefox() && isSpecialTheme){
  if (window.LAYOUT_PREFIX_MAINSTORE){
    instance = window.LAYOUT_PREFIX_MAINSTORE;
  } else {
    window.LAYOUT_PREFIX_MAINSTORE = instance;
  }
}

export default instance;

export type MainStoreType = Pick<MainStore, keyof MainStore>;
